/**
 * Single source of truth for monospace / tabular data typography.
 * Use FONT_MONO, monoFontSx, or className={MONO_FONT_CLASS} — never raw 'monospace'.
 */

export const FONT_MONO = '"JetBrains Mono", "SFMono-Regular", "Consolas", monospace';

export const MONO_FONT_CLASS = "font-mono";

export const monoTabularProps = {
  fontFeatureSettings: '"tnum" 1',
  fontVariantNumeric: "tabular-nums",
};

/** Drop into MUI `sx` for inline mono data/code. */
export const monoFontSx = {
  fontFamily: FONT_MONO,
  fontWeight: 400,
  ...monoTabularProps,
};

/** Table / data cells — forces JetBrains Mono on nested Typography and spans. */
export const monoDataCellSx = {
  ...monoFontSx,
  "& .MuiTypography-root, & span, & a": {
    fontFamily: `${FONT_MONO} !important`,
    fontWeight: 400,
    ...monoTabularProps,
  },
};
